module.exports = __webpack_public_path__ + "static/media/ProductImageFail.9ce308ca.png";